import React, { useEffect, useRef, useState } from 'react';
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import { ZIM } from 'zego-zim-web';
function randomID(len) {
  let result = '';
  if (result) return result;
  var chars = '12345qwertyuiopasdfgh67890jklmnbvcxzMNBVCZXASDQWERTYHGFUIOLKJP',
    maxPos = chars.length,
    i;
  len = len || 5;
  for (i = 0; i < len; i++) {
    result += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return result;
}

// get token
function generateToken(tokenServerUrl: string, userID: string) {
  // Obtain the token interface provided by the App Server
  return fetch(
    `${tokenServerUrl}/access_token?userID=${userID}&expired_ts=7200`,
    {
      method: 'GET',
    }
  ).then((res) => res.json());
}

// const userID = randomID(5);
// const userName = 'user_' + userID;
export default function ChatCallInvitation() {
  const roomID = "room01";
  const userID = localStorage.getItem("user_name");
  const userName = userID;
  const [callees, setCallees] = useState('');
  const [zp, setZp] = useState(null);
  const [showCancel, setShowCancel] = useState(false);
  const cancelButton = useRef(null);
  const mounted = async (el: HTMLDivElement) => {
    if (!el || zp) return;
    // generate token
    // const { token } = await generateToken(
    //   'https://nextjs-token-callinvitation.vercel.app/api',
    //   userID
    // );

    const appID = 1485872462;
    const serverSecret = "8e9ec2e8a91d24fd83fc68a74bda9f04";
    const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      roomID,
      userID,
      userName
    );
    const myZp = ZegoUIKitPrebuilt.create(TOKEN);
    myZp.addPlugins({ ZIM });
    myZp.setCallInvitationConfig({
      enableCustomCallInvitationWaitingPage: true,
      onSetRoomConfigBeforeJoining: () => ({
        turnOnCameraWhenJoining: false,
        showMyCameraToggleButton: false,
        showAudioVideoSettingsButton: false,
        showScreenSharingButton: false,
        showTextChat: false,
        showOnlyAudioUser: true,
        showNonVideoUser: true,
        useFrontFacingCamera: false,
        autoLeaveRoomWhenOnlySelfInRoom: true,

        branding: {
          logoURL:
            "data:image/png;base64,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",
        },
        onUserAvatarSetter: (userList) => {
          const userImage = localStorage.getItem('user_image')
          userList.forEach((user) => {
            user.setUserAvatar(
              userImage
            );
          });
        },
      }),
      onWaitingPageWhenSending: (callType, callees, cancel) => {
        setShowCancel(true);
        console.warn(cancelButton);
        cancelButton.current.onclick = () => {
          alert(1);
          cancel();
          setShowCancel(false);
        };
      },
    });
    setZp(myZp);
  };

  const handleSendCallInvitation = (callType: number) => {

    const values = callees.split(',');
    const invitees = values
      .filter((v) => v.length)
      .map((v) => ({
        userID: v,
        userName: 'user_' + v,
      }));
    zp.sendCallInvitation({
      callees: invitees,
      callType: callType,
      timeout: 60,
    })
      .then((res) => {
        console.warn(res);
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  return (
    <div
      className="myCallContainer"
      style={{ width: '100vw', height: '100vh' }}
      ref={mounted}
    >
      <div className="callInvitationWrapper">
        <div className="invitationModel">
          <div className="invitationUserHeader">
            <div className="invitationAvatar">{userName.slice(0, 1)}</div>
            <div className="invitationUserInf">
              <p>userName: {userName}</p>
              <span>userID: {userID}</span>
            </div>
          </div>
          <p className="invitationTitle">Make a direct call</p>
          <input
            className="invitationInput"
            type="text"
            placeholder={'Enter callees\' user id, separate them by ","'}
            value={callees}
            required
            onInput={(e: any) => {
              setCallees(e.target.value);
            }}
            onChange={(e: any) => {
              setCallees(e.target.value);
            }}
          />
          <div
            className="invitationVideoCallBtn"
            onClick={() => {
              handleSendCallInvitation(1);
            }}
          >
            Video call
          </div>
          <div
            className="invitationVoiceCallBtn"
            onClick={() => {
              handleSendCallInvitation(0);
            }}
          >
            Voice call
          </div>
        </div>
      </div>
      <button
        style={{ display: showCancel ? 'block' : 'none' }}
        ref={cancelButton}
      >
        End call1111
      </button>
    </div>
  );
}
